// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2kY84","itemTitle":"ClientEmergencyInfo_itemTitle__3NI3U","itemText":"ClientEmergencyInfo_itemText__2ZwIQ"};